import React, { Component } from "react";
import { Link } from "react-router-dom";

import UI from "../../actions/ui-helper";
import StringUtil from "../../actions/string";
import {
  formatCurrency,
  formatPago,
  formatSituacao,
  formatPeriodicidade,
} from "../main/utils/utils";
import DataUtil from "../../actions/data.js";

class ConsultaCategoriaResultado extends Component {
  componentWillUpdate() {
    UI.destroyTable(this.tableId);
  }

  componentDidUpdate() {
    UI.dataTable(this.tableId);
  }

  render() {
    if (this.props.resultado.length === 0) {
      return false;
    }
    this.tableId = StringUtil.uuid(5);

    return (
      <div className="row">
        <div className="col-12 grid-margin">
          <div className="row">
            <div className="col-12 table-responsive">
              <table
                key={StringUtil.uuid(5)}
                id={this.tableId}
                className="table"
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Origem</th>
                    <th>Data</th>
                    <th>Descrição</th>
                    <th>Nota Fiscal</th>
                    <th>Pago a</th>
                    <th>Forma de Pagamento</th>
                    <th>Valor</th>
                    <th>Categoria</th>
                    <th>Situação</th>
                    <th>Periodicidade</th>
                    <th>Tipo</th>
                    <th>Observação</th>
                    <th>Pago</th>
                    <th>Opções</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.resultado.map((lancamento, i) => {
                    return (
                      <tr>
                        <td style={{ width: "1%" }}>{lancamento.id}</td>
                        <td style={{ width: "1%" }}>{lancamento.origem}</td>
                        <td style={{ width: "1%" }}>
                          {DataUtil.dateISOToDateMasked(lancamento.data)}
                        </td>
                        <td style={{ width: "1%" }}>{lancamento.descricao}</td>
                        <td style={{ width: "1%" }}>{lancamento.notaFiscal}</td>
                        <td style={{ width: "1%" }}>{lancamento.pagoDe}</td>
                        <td style={{ width: "1%" }}>
                          {lancamento.formaPagamento
                            ? lancamento.formaPagamento.descricao
                            : ""}
                        </td>
                        <td style={{ width: "1%" }}>
                          {formatCurrency(lancamento.valor)}
                        </td>
                        <td style={{ width: "1%" }}>
                          {lancamento.categoria
                            ? lancamento.categoria.descricao
                            : ""}
                        </td>
                        <td style={{ width: "1%" }}>
                          {formatSituacao(lancamento.situacao)}
                        </td>
                        <td style={{ width: "1%" }}>
                          {formatPeriodicidade(lancamento.periodicidade)}
                        </td>
                        <td style={{ width: "1%" }}>{lancamento.tipo}</td>
                        <td style={{ width: "1%" }}>{lancamento.observacao}</td>
                        <td style={{ width: "1%" }}>
                          {formatPago(lancamento.pago)}
                        </td>

                        <td style={{ width: "1%" }}>
                          <button
                            className="btn btn-xs btn-light btn-option icon-btn"
                            type="button"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            <i className="fa fa-cog"></i>
                          </button>
                          <div className="dropdown-menu">
                            <Link
                              to={"/financeiro/cadastro/" + lancamento.id}
                              className="dropdown-item"
                            >
                              <i className="fa fa-edit"></i>
                              &nbsp;Editar
                            </Link>
                            <span
                              onClick={() =>
                                this.props.onExcluir(lancamento.id)
                              }
                            >
                              <Link
                                to={"/financeiro/consulta"}
                                className="dropdown-item"
                              >
                                <i className="fa fa-times"></i>
                                &nbsp;Excluir
                              </Link>
                            </span>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ConsultaCategoriaResultado;
